import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PeopleService } from 'app/profile/services/people.service';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { JobTitle, Department, JobRole } from 'app/profile/models/people.model';
import { TslOption } from '@tesla/ng-tds';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
    templateUrl: './jobtitle-form-dialog.component.html',
    styleUrls: ['./jobtitle-form-dialog.component.scss']
})
export class JobtitleFormDialogComponent implements OnInit {
    jobroleForm: FormGroup;
    // sources
    jobtitles: JobTitle[];
    departments: Department[];

    get jobtitle() { return this.jobroleForm.get('jobtitle'); }
    get department() { return this.jobroleForm.get('department'); }

    constructor(
        private fb: FormBuilder,
        private service: PeopleService,
        public dialogRef: MatDialogRef<JobtitleFormDialogComponent>,
        private translate: I18nService,
        @Inject(MAT_DIALOG_DATA) public data: JobRole) {
        this.jobroleForm = this.fb.group({
            jobtitle: ['', Validators.required],
            department: ['', Validators.required],
        })
    }

    ngOnInit() {
        this.loadResources();

        if (this.data.id > 0) {
            this.jobroleForm.patchValue({
                jobtitle: this.data.jobTitle,
                department: this.data.department
            });
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.jobroleForm.invalid) {
            return;
        }

        const job = this.jobtitles.find(x => x.name === this.jobtitle.value);
        this.data.jobTitleId = job ? job.id : 0;
        this.data.jobTitle = this.jobtitle.value;

        const department = this.departments.find(x => x.name === this.department.value);
        this.data.departmentId = department ? department.id : 0;
        this.data.department = this.department.value;

        this.dialogRef.close(this.data);
    }

    onSelectJobtitle(option: TslOption): void {
        this.jobtitle.setValue(option.value);
    }

    onSelectDepartment(option: TslOption): void {
        this.department.setValue(option.value);
    }

    private loadResources(): void {
        this.service.getJobtitles(this.data.supplierCode).subscribe(res => this.jobtitles = res);
        this.service.getDepartments(this.data.supplierCode).subscribe(res => this.departments = res);
    }
}
